import Global from '../shared/global';

'use strict';
const HomepageProducts = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.redirectToBooking();
	},

	redirectToBooking() {
		const cards = document.querySelectorAll('.js-slider-cards__slide');
		if (!cards) {
			return false;
		}

		const preselectProductOnBooking = async function() {
			const productId = this.getAttribute('data-id');
			const productName = this.getAttribute('data-name');
			console.log(productId);
			if (productId !== '') {
				await Global.setCookie('extraPriceTotal', {
					parent: productName,
					parentId: productId,
					childrenIds: [],
					children: [],
				});
				location.href = this.getAttribute('data-steps');
			}
		};

		for (let i = 0; i < cards.length; i++) {
			cards[i].addEventListener('click', preselectProductOnBooking);
		}
	}
};

export default HomepageProducts;
